import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import RedirectToUrlData from '../../../Models/Content/RedirectToUrlBlockData'
import RedirectBox from './RedirectBox'

export default class RedirectToUrl extends EpiComponent<RedirectToUrlData>
{
    constructor(props) {
        super(props);  
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <RedirectBox context={this.getContext()} iContent={this.props.data} />    
        );
    }
}